import React, { useState, useEffect } from "react";
import { withApollo } from "react-apollo";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import gql from "graphql-tag";
import { CVD_PRODUCTS_LIST, CVD_PRODUCT_DETAILS, CVD_COMPARISON_LIST } from "../../graphql/query";

const CREATE_CVD = gql`
  mutation CreateDiamondComparison(
    $tagNo: String!
    $name: String
    $naturalDiamondMetalWeight: String
    $naturalDiamondPurity: String
    $naturalDiamondMetalValue: String
    $naturalDiamondDiamondType: String
    $naturalDiamondNoOfDiamonds: String
    $naturalDiamondDiamondCarat: String
    $naturalDiamondDiamondPrice: String
    $naturalDiamondCertificate: String
    $naturalDiamondTotalPrice: String
    $metalWeight: String
    $purity: String
    $metalValue: String
    $diamondType: String
    $noOfDiamonds: String
    $diamondCarat: String
    $diamondPrice: String
    $certificate: String
    $totalPrice: String
    $totalSaved: String
    $diamondInProductValue: String
    $makingCharge: String
    $gstPercentage: String
    $gstValue: String
    $metalPrice: String
    $addOnPercentage: String
  ) {
    createDiamondComparison(
      input: {
        diamondComparison: {
          tagNo: $tagNo
          name: $name
          naturalDiamondMetalWeight: $naturalDiamondMetalWeight
          naturalDiamondPurity: $naturalDiamondPurity
          naturalDiamondMetalValue: $naturalDiamondMetalValue
          naturalDiamondDiamondType: $naturalDiamondDiamondType
          naturalDiamondNoOfDiamonds: $naturalDiamondNoOfDiamonds
          naturalDiamondDiamondCarat: $naturalDiamondDiamondCarat
          naturalDiamondDiamondPrice: $naturalDiamondDiamondPrice
          naturalDiamondCertificate: $naturalDiamondCertificate
          naturalDiamondTotalPrice: $naturalDiamondTotalPrice
          metalWeight: $metalWeight
          purity: $purity
          metalValue: $metalValue
          diamondType: $diamondType
          noOfDiamonds: $noOfDiamonds
          diamondCarat: $diamondCarat
          diamondPrice: $diamondPrice
          certificate: $certificate
          totalPrice: $totalPrice
          totalSaved: $totalSaved
          diamondInProductValue: $diamondInProductValue
          makingCharge: $makingCharge
          gstPercentage: $gstPercentage
          gstValue: $gstValue
          metalPrice: $metalPrice
          addOnPercentage: $addOnPercentage
        }
      }
    ) {
      diamondComparison {
        tagNo
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(3) },
  header: { display: "flex", alignItems: "center", marginBottom: theme.spacing(3) },
  title: { marginLeft: theme.spacing(1) },
  section: { marginBottom: theme.spacing(3), padding: theme.spacing(2) },
  sectionTitle: { marginBottom: theme.spacing(2), fontWeight: "bold", color: "#1976d2" },
  actions: { marginTop: theme.spacing(3), display: "flex", gap: theme.spacing(2) },
}));

const fields = [
  { section: "Basic Info", fields: [
    { key: "tagNo", label: "Tag No", disabled: true },
    { key: "name", label: "Name", disabled: true },
    { key: "productVendorCode", label: "Product Vendor Code", disabled: true },
  ]},
  { section: "Natural Diamond Details", fields: [
    { key: "naturalDiamondMetalWeight", label: "ND Metal Weight" },
    { key: "naturalDiamondPurity", label: "ND Purity" },
    { key: "naturalDiamondMetalValue", label: "ND Metal Value" },
    { key: "naturalDiamondDiamondType", label: "ND Diamond Type" },
    { key: "naturalDiamondNoOfDiamonds", label: "ND No of Diamonds" },
    { key: "naturalDiamondDiamondCarat", label: "ND Diamond Carat" },
    { key: "naturalDiamondDiamondPrice", label: "ND Diamond Price" },
    { key: "naturalDiamondCertificate", label: "ND Certificate" },
    { key: "naturalDiamondTotalPrice", label: "ND Total Price" },
  ]},
  { section: "CVD Diamond Details", fields: [
    { key: "metalWeight", label: "Metal Weight", autoPopulated: true },
    { key: "purity", label: "Purity", autoPopulated: true },
    { key: "metalValue", label: "Metal Value", autoPopulated: true },
    { key: "diamondType", label: "Diamond Type", autoPopulated: true },
    { key: "noOfDiamonds", label: "No of Diamonds", autoPopulated: true },
    { key: "diamondCarat", label: "Diamond Carat", autoPopulated: true },
    { key: "diamondPrice", label: "Diamond Price (per carat)", autoPopulated: true },
    { key: "certificate", label: "Certificate" },
    { key: "totalPrice", label: "Total Price" },
    { key: "totalSaved", label: "Total Saved" },
  ]},
  { section: "Additional Details", fields: [
    { key: "diamondInProductValue", label: "Diamond In Product Value" },
    { key: "makingCharge", label: "Making Charge" },
    { key: "gstPercentage", label: "GST%" },
    { key: "gstValue", label: "GST Value" },
    { key: "metalPrice", label: "Metal Price" },
    { key: "addOnPercentage", label: "Add On%" },
  ]},
];

export const CVDAdd = withApollo((props) => {
  const classes = useStyles();
  const history = useHistory();
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ open: false, text: "", type: "success" });
  const [cvdProducts, setCvdProducts] = useState([]);
  const [existingTagNos, setExistingTagNos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    try {
      const [productsResult, comparisonsResult] = await Promise.all([
        props.client.query({ query: CVD_PRODUCTS_LIST, fetchPolicy: "network-only" }),
        props.client.query({ query: CVD_COMPARISON_LIST, fetchPolicy: "network-only" }),
      ]);
      setCvdProducts(productsResult.data.allProductLists.nodes);
      setExistingTagNos(comparisonsResult.data.allDiamondComparisons.nodes.map(n => n.tagNo));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const handleProductSelect = async (event, value) => {
    if (!value) {
      setFormData({});
      return;
    }
    setFormData({ tagNo: value.productId, name: value.productName, productVendorCode: value.productVendorCode || "" });
    try {
      const result = await props.client.query({
        query: CVD_PRODUCT_DETAILS,
        variables: { productId: value.productId },
        fetchPolicy: "network-only",
      });
      const product = result.data.productListByProductId;
      if (product) {
        const sku = product.transSkuListsByProductId?.nodes?.[0];
        const diamonds = product.productDiamondsByProductSku?.nodes || [];
        const totalStoneCount = diamonds.reduce((sum, d) => sum + (parseInt(d.stoneCount) || 0), 0);
        const totalStoneWeight = diamonds.reduce((sum, d) => sum + (parseFloat(d.stoneWeight) || 0), 0);
        const diamondType = sku?.diamondType || diamonds[0]?.diamondType || "";
        setFormData({
          tagNo: value.productId,
          name: value.productName,
          productVendorCode: value.productVendorCode || "",
          metalWeight: sku?.skuWeight ? String(sku.skuWeight) : "",
          purity: sku?.purity ? String(sku.purity) : "",
          metalValue: sku?.markupPrice ? String(sku.markupPrice) : "",
          diamondType: diamondType ? String(diamondType) : "",
          noOfDiamonds: totalStoneCount ? String(totalStoneCount) : "",
          diamondCarat: totalStoneWeight ? String(totalStoneWeight) : "",
          diamondPrice: sku?.sellingPrice ? String(sku.sellingPrice) : "",
        });
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  const handleSave = async () => {
    if (!formData.tagNo) {
      setMessage({ open: true, text: "Please select a CVD product", type: "error" });
      return;
    }
    if (existingTagNos.includes(formData.tagNo)) {
      setMessage({ open: true, text: "Tag No already exists in comparison list", type: "error" });
      return;
    }
    setSaving(true);
    try {
      const { tagNo, productVendorCode, ...input } = formData;
      await props.client.mutate({
        mutation: CREATE_CVD,
        variables: { tagNo, ...input },
      });
      setMessage({ open: true, text: "Record added successfully", type: "success" });
      setTimeout(() => history.push("/cvd"), 1000);
    } catch (error) {
      console.error("Error adding record:", error);
      setMessage({ open: true, text: "Failed to add record", type: "error" });
    }
    setSaving(false);
  };

  if (loading) {
    return <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><CircularProgress /></div>;
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <IconButton onClick={() => history.push("/cvd")}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" className={classes.title}>
          Add CVD Diamond Comparison
        </Typography>
      </div>

      <Paper className={classes.section} elevation={2}>
        <Typography variant="subtitle1" className={classes.sectionTitle}>
          Select Product
        </Typography>
        <Autocomplete
          options={cvdProducts.filter(p => !existingTagNos.includes(p.productId))}
          getOptionLabel={(option) => `${option.productId} - ${option.productName}${option.productVendorCode ? ` (${option.productVendorCode})` : ""}`}
          onChange={handleProductSelect}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select CVD Product (Lab Grown Diamond)"
              variant="outlined"
              size="small"
              fullWidth
            />
          )}
        />
      </Paper>

      {fields.map((section) => (
        <Paper key={section.section} className={classes.section} elevation={2}>
          <Typography variant="subtitle1" className={classes.sectionTitle}>
            {section.section}
          </Typography>
          <Grid container spacing={2}>
            {section.fields.map((field) => (
              <Grid item xs={12} sm={6} md={4} key={field.key}>
                <TextField
                  label={field.label}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formData[field.key] || ""}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  disabled={field.disabled}
                  InputProps={{ readOnly: field.autoPopulated && !!formData[field.key] }}
                />
              </Grid>
            ))}
          </Grid>
        </Paper>
      ))}

      <div className={classes.actions}>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
        <Button variant="outlined" onClick={() => history.push("/cvd")}>
          Cancel
        </Button>
      </div>

      <Snackbar open={message.open} autoHideDuration={3000} onClose={() => setMessage({ ...message, open: false })}>
        <Alert severity={message.type} onClose={() => setMessage({ ...message, open: false })}>
          {message.text}
        </Alert>
      </Snackbar>
    </div>
  );
});

export default CVDAdd;
